import React from "react";

const ADO_Display = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Display</h1>
      <p>This is the ADO Display page content.</p>
    </div>
  );
};

export default ADO_Display;
